import React, {useEffect, useState, useRef, useContext} from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import EditableGrid from 'components/EditableGrid/EditableGrid';
import { DataContext } from 'contexts/DataContext';
import { GridColDef } from '@mui/x-data-grid';

import Typography from '@mui/material/Typography';
import People from '@mui/icons-material/People';
import Add from '@mui/icons-material/Add';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { get, getRoles, update, destroy, getColumns } from './api';
import { get as getOrganizations } from '../Organization/api';

function Users() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const addButtonRef = useRef(null);
  const [columns, setColumns] = useState([] as GridColDef[]);
  const [decodeOrganizationLoaded, setDecodeOrganizationLoaded] = useState(false);
  const [decodeRoleLoaded, setDecodeRoleLoaded] = useState(false);

  useEffect(() => {
    if(dataContext.loading) return;
    
    getColumns(dataContext.language).then((response) => {
      setColumns(response);
      let columns = response;

      getOrganizations().then((response) => {
        let col = columns.filter(column => column.field === "id_organization")[0] as any;
        if(col) {
          col.valueOptions = response.map((organization:any) => { return {value: organization.id, label: organization.name} });
          setDecodeOrganizationLoaded(true);
        }
      });
  
      getRoles().then((response:any) => {
        let col = columns.filter(column => column.field === "id_role")[0] as any;
        if(col) {
          col.valueOptions = response.map((role:any) => { return {value: role.id, label: role.name} });
          setDecodeRoleLoaded(true);
        }
      });
      
    });
  }, [dataContext.loading, dataContext.language]);

  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
    title={<><Typography variant='pageTitle'>{t('Users')}</Typography></>}
    actions={[
      {
        label: t('Add user'),
        icon:<Add />,
        action: () => {
          let addbutton = addButtonRef.current as any;
          addbutton.click();
        }
      }
    ]}>
    {decodeOrganizationLoaded && decodeRoleLoaded && 
    <EditableGrid addButtonRef={addButtonRef} hideAddButton={true} columns={columns} get={get} update={update} delete={destroy} 
      name='userGrid'
      reloadParentOnEditStop={true}
      labels={{
        "actions": t('Actions'),
        "add": {
          "button": t("Add user")
        }
      }}/>}
    </AppLayout>
  );
}

export default Users;
